module.exports = __webpack_public_path__ + "img/icon8.c9e4025d.png";